import {
    POST_TEXT_UPDATE,
    POST_SEND,
    POST_SEND_SUCCESS,
    POST_SEND_FAIL,
    POST_UPDATE_POSTS,
    POST_UPDATE_POSTS_FAIL,
    POST_UPDATE_POSTS_SUCCESS,
} from './types';

import { MURAL_GET, MURAL_POST} from "../../screens/mural/api/muralEndpoints";
import post from "../../api/methods/post";
import get from "../../api/methods/get";

export const muralPostUpdate = (newText) => {
    return {
        type: POST_TEXT_UPDATE,
        payload: newText
    };
};

export const sendMuralPostAsync = (user, userName, userAvatarColor, postText, postImage, authToken) => {
    return async (dispatch) => {
        dispatch({ type: POST_SEND, payload: 'sending new post' });

        if (postText === '') {
            postSendFailed(dispatch, 'Post está vazio.');
            throw ({ message: 'Post está vazio.' });
        }

        const body = {
            creatorId: user,
            creatorName: userName,
            creatorAvatarColor: userAvatarColor,
            postText: postText,
            postImage: postImage,
        };

        try {
            let postRaw = await post(MURAL_POST, body, authToken);
            let postJson = await postRaw.json();
            console.log(postJson);

            postSendSuccess(dispatch);
            return({ message: 'Sucesso ao enviar o post.' });

        } catch (e) {
            console.log(e);
            postSendFailed(dispatch, e);
            throw ({ message: 'Erro ao enviar o post', error: e });
        }
    };
};

//Action to inform that the send action has failed.
const postSendFailed = (dispatch, error) => {
    dispatch({
        type: POST_SEND_FAIL,
        payload: error
    });
};

//Action to inform that the send action has succesed.
const postSendSuccess = (dispatch) => {
    dispatch({ type: POST_SEND_SUCCESS, payload: 'Post enviado com sucesso!' });
};

//Action to get all the posts inside the db.
export const getPosts = (authToken) => {
    return async (dispatch) => {
        dispatch({ type: POST_UPDATE_POSTS, payload: 'updating posts' });

        try {
            const getResult = await get(MURAL_GET, authToken);
            const json = await getResult.json();
            getPostSuccess(dispatch, json.data.Items);
        } catch (e) {
            console.log(e);
        }
    };
};

//Action to inform that the get post failed.
const getPostFailed = (dispatch, errorText) => {
    dispatch({
        type: POST_UPDATE_POSTS_FAIL,
        payload: errorText
    });
};

//Action to inform that the get post succed
const getPostSuccess = (dispatch, items) => {
    dispatch({
        type: POST_UPDATE_POSTS_SUCCESS,
        payload: items
    });
};
